import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flow__content" }
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "1",
  rx: "3",
  ry: "3",
  width: "75",
  height: "5"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "9",
  rx: "3",
  ry: "3",
  width: "85",
  height: "4"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "20",
  rx: "3",
  ry: "3",
  width: "30",
  height: "15"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  x: "35",
  y: "20",
  rx: "3",
  ry: "3",
  width: "30",
  height: "15"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "70",
  y: "20",
  rx: "3",
  ry: "3",
  width: "30",
  height: "15"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "41",
  rx: "3",
  ry: "3",
  width: "25",
  height: "4"
}, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "alert alert--error"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "editable-header spacing-bottom-1-xs spacing-bottom-2-sm" }
const _hoisted_13 = { class: "m-content-section__subtitle" }
const _hoisted_14 = { class: "spacing-top-3-xs spacing-bottom-3-xs" }
const _hoisted_15 = { class: "a-input-radiocargroup" }
const _hoisted_16 = ["value", "onUpdate:modelValue"]
const _hoisted_17 = { class: "a-input-radiocar__button" }
const _hoisted_18 = { class: "a-input-radiocar__icon" }
const _hoisted_19 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  focusable: "false"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M68.39 40.64c-.69-.21-1.28.21-1.53.9l-.58 2.17c-.21.73.47 1.57 1.22 1.57\"></path><path d=\"M29.69 61.21a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92-.01.13-.01.25-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4 1.32 0 2.4-1.08 2.4-2.4zm59.81.38a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92-.01.13-.01.25-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4 1.32 0 2.4-1.08 2.4-2.4zm0 0\" fill=\"currentColor\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M47.11 33.32L47.1 44.5l22.88.86s2.56.18 2.56-2.31\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M47.11 33.32L47.1 44.5l-20.02-.59s-.54-10.05 8.43-10.6\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M91.61 46.98c-2.96-1.23-11.43-2.29-14.78-2.68-3.35-.39-5.58-2.01-5.58-2.01s-5.19-2.9-9.87-5.86c-4.69-2.96-8.7-3.12-8.7-3.12H35.95c-4.35 0-7.14 1.28-7.14 1.28l-14.67 6.64H6.05c-2.68 0-2.4 2.45-2.4 2.45v5.63s-1.3 1.62-1.3 3.51.12 2.82 1.3 3.77c1.17.95 9.38 2.4 9.38 2.4l1.19 1.56h1.54c.14-4.35 3.69-7.85 8.08-7.85s7.94 3.49 8.08 7.85h40.21c.14-4.35 3.69-7.85 8.08-7.85 4.39 0 7.94 3.49 8.08 7.85h7.43s1.91.13 1.91-1.97v-4.87c.01-4-3.06-5.5-6.02-6.73zm-40.84.45l3.07.08m-23.79-.68l3.07.08\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M94.37 48.26l-3.62-.2c-.89-.14-1.4.56-1.08 1.25.74 1.58.99 1.58 1.64 1.63l4.71.24h.64\"></path>", 6)
const _hoisted_26 = [
  _hoisted_20
]
const _hoisted_27 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  focusable: "false"
}
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M67.81 41.86c-.66-.2-1.24.2-1.48.87l-.57 1.9c-.2.71.46 1.52 1.18 1.52\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M45.91 34.66v10.42l-10.44-.43c-4.29-2.66-2.87-9.8-2.87-9.8m37.97 8.98c0 2.48-1.66 2.42-1.66 2.42l-23-1.18V34.66\"></path><path d=\"M28.54 60.28a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92 0 .13-.01.26-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4 1.33 0 2.4-1.07 2.4-2.4zm54.16.38a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92-.01.13-.02.26-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4a2.4 2.4 0 002.4-2.4zm0 0\" fill=\"currentColor\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M70.57 43.83l-7.77-5.54c-4.17-3.03-7.94-3.37-7.94-3.37-14.17-1.66-31.19.29-31.19.29s-.8.17-2.14.31c-1.34.14-.31 1.29-.49 1.97-.17.69-5.99 5.71-7.71 7.83-1.71 2.11-1.49 4.46-1.49 4.46v6.3l1.45 3.83h1.31c0-4.48 3.63-8.1 8.11-8.1 4.48 0 8.11 3.63 8.11 8.1h34.5c0-4.48 3.63-8.1 8.11-8.1 4.48 0 8.11 3.63 8.11 8.1h4.76c1.94 0 1.89-2.34 1.89-2.34v-6.13c-2.48-7.04-17.62-7.61-17.62-7.61zm-21.72 4.18l3.07.14m-15.26-.74l3.07.14\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M85.88 48.26l-3.62-.2c-.89-.14-1.4.56-1.08 1.25.74 1.58.99 1.58 1.64 1.63l4.71.24h.64\"></path>", 5)
const _hoisted_33 = [
  _hoisted_28
]
const _hoisted_34 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  focusable: "false"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<path d=\"M31.27 60.1a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92 0 .13-.01.26-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4 1.33 0 2.4-1.07 2.4-2.4zm49.02.38a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92-.01.13-.01.26-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4a2.4 2.4 0 002.4-2.4zm0 0\" fill=\"currentColor\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M62.39 41.35c-.66-.2-1.24.2-1.48.87l-.57 1.9c-.2.71.46 1.52 1.18 1.52m-19.46-8.77v7.84l-5.2-.44-5.15-1.37s-2.83-.21-2.37-3.19l.47-4.52\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M42.06 34.43v10.29l21.31 1.03s1.66.06 1.66-2.42\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M76.07 45.24c-3.11-1.04-11.04-1.91-11.04-1.91s-2.81-2.29-7.2-5.04c-4.38-2.75-11.39-3.86-17.67-3.86-6.28 0-14.59 1.37-14.59 1.37s-3.29-.01-4.02-.01c-.73 0-.26.81-.26.81l1.28 1.25s-2.57 2.9-3.71 4.22c-1.14 1.32-1.03 2.79-1.06 4.96-.04 2.16-.51 3.19-1.43 4.36-.92 1.17-1.03 2.79-1.03 2.79v2.42c0 1.25 1.92 3.13 1.92 3.13 0-4.48 3.63-8.11 8.11-8.11 4.48 0 8.11 3.63 8.11 8.11h29.41c0-4.48 3.63-8.11 8.11-8.11 4.48 0 8.11 3.63 8.11 8.11h5.55V52.4c-.01-2.37-5.45-6.12-8.59-7.16zm-31.44 2.58l3.07.16\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M81.46 48.26l-3.62-.2c-.89-.14-1.4.56-1.08 1.25.74 1.58.99 1.58 1.64 1.63l4.71.24h.64\"></path>", 5)
const _hoisted_40 = [
  _hoisted_35
]
const _hoisted_41 = { class: "a-input-radiocar__label" }
const _hoisted_42 = {
  key: 0,
  class: "spacing-bottom-2-xs"
}
const _hoisted_43 = { class: "a-input-costcalc--checkbox" }
const _hoisted_44 = { for: "isElectric" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("svg", {
  focusable: "false",
  viewBox: "-1 1 16 12",
  width: "50px",
  height: "50px"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    stroke: "#32AB52",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M13.105 3L8.123 8.143l-2.491 2.571-3.737-3.857"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_content_loader, { viewBox: "0 0 100 50" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.message || _ctx.$t("error-general-fault")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h3", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("own-car-type-question")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("own-car-type-text")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carSizes, (carSize) => {
                        return (_openBlock(), _createElementBlock("label", {
                          class: "a-input-radiocar",
                          key: carSize.Id
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "carSize",
                            value: carSize.Name,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.selectedOwnCarType.carSize) = $event)
                          }, null, 8, _hoisted_16), [
                            [_vModelRadio, _ctx.selectedOwnCarType.carSize]
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              (carSize.Name === 'midrange')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_26))
                                : (carSize.Name === 'small-midrange')
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_27, _hoisted_33))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_34, _hoisted_40))
                            ]),
                            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.getCarSizeTranslation(carSize.Name)), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.carSizes.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _withDirectives(_createElementVNode("input", {
                            id: "isElectric",
                            type: "checkbox",
                            name: "isElectric",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOwnCarType.isElectric) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.selectedOwnCarType.isElectric]
                          ]),
                          _createElementVNode("label", _hoisted_44, [
                            _hoisted_45,
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("own-car-type-electric-option")), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ]))
  ]))
}